import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_currency_stats = (startDate = null, endDate = null) => {
  let url = `${ApiEndpointConstants.GET_CURRENCY_STATS}`;
  const params = [];

  if (startDate) {
    params.push(`start_date=${encodeURIComponent(startDate)}`);
  }
  if (endDate) {
    params.push(`end_date=${encodeURIComponent(endDate)}`);
  }

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  // 后端使用GET方法
  return api.get(url);
};
